import { render, staticRenderFns } from "./ModalResetPassword.vue?vue&type=template&id=fc870208&scoped=true&"
import script from "./ModalResetPassword.vue?vue&type=script&lang=js&"
export * from "./ModalResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalResetPassword.vue?vue&type=style&index=0&id=fc870208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc870208",
  null
  
)

export default component.exports